module.exports = __webpack_public_path__ + "static/media/quote-left.0f132b3e.svg";